import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function DoneList(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="doneList-paint0_linear"
          x1="109.511"
          x2="62.3945"
          y1="9.05403"
          y2="110.491"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="doneList-paint1_linear"
          x1="69.5807"
          x2="100.73"
          y1="-0.36454"
          y2="107.821"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="doneList-paint2_linear"
          x1="56.5044"
          x2="61.6221"
          y1="3.43835"
          y2="22.0263"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
      </defs>
      <path
        d="M130.076 18.5987C100.085 3.26502 91.1004 31.8401 55.2396 9.90315C23.2379 -9.66889 8.6397 17.6476 4.52417 26.9011C-0.551442 38.3039 -8.03195 66.9899 24.6265 78.0946C66.4573 92.3156 64.2244 115.641 96.4794 125.579C122.342 133.546 146.103 122.114 157.221 87.3608C165.599 61.1728 154.6 31.1395 130.076 18.5987Z"
        fill="url(#doneList-paint0_linear)"
      />

      <g opacity="0.71">
        <path
          d="M120.977 0L121 101.984L48.0196 102L48 20.2001L68.2687 0.0129779L120.977 0Z"
          fill="url(#doneList-paint1_linear)"
        />

        <rect fill="#BBCBEA" height="4" rx="2" width="37" x="76" y="39" />

        <rect fill="#B3C4E7" height="4" rx="2" width="37" x="76" y="59" />

        <rect fill="#A6B8DC" height="4" rx="2" width="37" x="76" y="79" />

        <path
          d="M68.9966 0L69 19.9936L48 20L68.9966 0Z"
          fill="url(#doneList-paint2_linear)"
          opacity="0.71"
        />
      </g>

      <path
        clipRule="evenodd"
        d="M63 34C59.1427 34 56.0141 37.12 56 40.9739V41.0261C56.0141 44.88 59.1427 48 63 48C66.866 48 70 44.866 70 41C70 37.134 66.866 34 63 34Z"
        fill="#07BE6F"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M61.5272 44.1738L59.3228 42.0156C59.1162 41.8133 59.1127 41.4817 59.315 41.2751C59.5174 41.0683 59.8489 41.0649 60.0556 41.2672L61.5134 42.6945L65.9371 38.1984C66.14 37.9923 66.4714 37.9896 66.6776 38.1924C66.8838 38.3952 66.8865 38.7268 66.6837 38.9329L61.5272 44.1738Z"
        fill="white"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M63 54C59.1427 54 56.0141 57.12 56 60.9739V61.0261C56.0141 64.88 59.1427 68 63 68C66.866 68 70 64.866 70 61C70 57.134 66.866 54 63 54Z"
        fill="#07BE6F"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M61.5272 64.1738L59.3228 62.0156C59.1162 61.8133 59.1127 61.4817 59.315 61.2751C59.5174 61.0683 59.8489 61.0649 60.0556 61.2672L61.5134 62.6945L65.9371 58.1984C66.14 57.9923 66.4714 57.9896 66.6776 58.1924C66.8838 58.3952 66.8865 58.7268 66.6837 58.9329L61.5272 64.1738Z"
        fill="white"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M63 74C59.1427 74 56.0141 77.12 56 80.9739V81.0261C56.0141 84.88 59.1427 88 63 88C66.866 88 70 84.866 70 81C70 77.134 66.866 74 63 74Z"
        fill="#07BE6F"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M61.5272 84.1738L59.3228 82.0156C59.1162 81.8133 59.1127 81.4817 59.315 81.2751C59.5174 81.0683 59.8489 81.0649 60.0556 81.2672L61.5134 82.6945L65.9371 78.1984C66.14 77.9923 66.4714 77.9896 66.6776 78.1924C66.8838 78.3952 66.8865 78.7268 66.6837 78.9329L61.5272 84.1738Z"
        fill="white"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default DoneList
